import { GoogleContentApi } from "@app/api/generated";
import { getAuthorizedApiConfig } from "@app/util/api-config";
import { wait } from "@app/util/wait";

const syncGoogleContent = async (): Promise<{ type: "error" | "success"; message?: string }> => {
  try {
    // Faking actual syncing
    await wait(1000);
    const api = new GoogleContentApi(await getAuthorizedApiConfig());

    await api.updateGoogleCss();

    return { type: "success" };
  } catch {
    return { type: "error" };
  }
};

export { syncGoogleContent };
